import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { workspaceRouteForRole } from '@/config/authAllowlist';
import { useAuth } from '@/hooks/useAuth';

/**
 * Ensures unauthenticated visitors always end up on /login
 * (covers deep links and legacy bookmarks).
 */
export function AuthNavigationSync() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onLoginPage = location.pathname === ROUTES.LOGIN;

    if (!isAuthenticated || !user) {
      if (!onLoginPage) {
        navigate(ROUTES.LOGIN, { replace: true, state: { from: location.pathname } });
      }
      return;
    }

    if (onLoginPage) {
      navigate(workspaceRouteForRole(user.role), { replace: true });
    }
  }, [isAuthenticated, user, location.pathname, navigate]);

  return null;
}
